import React, { Component } from "react";
import parse from "html-react-parser";
export default class Renditingimused extends Component {
  // https://elon.ee/wp/wp-json/acf/v3/options/options_developments?lang=et
  constructor(props) {
    super(props);
    this.state = { content: null };
  }
  async componentDidMount() {
    await this.fetchInfo();
  }
  async fetchInfo() {
    const response = await fetch(
      `https://www.skodalaagri.ee/wp-json/acf/v3/options/options_rent`
    );
    const json = await response.json();
    //console.log(json.acf.renditingimused);
    this.setState({ content: json.acf.renditingimused });
    //  this.setState({ car: model["acf"] }, () => this.setImages());
  }

  render() {
    return <div>{this.state.content ? parse(this.state.content) : ""}</div>;
  }
}
